import { useQuery } from "@tanstack/react-query";

import { ReactQueryKeys } from "../services/ReactQueryKeys.ts";
import { useTemplateService } from "../services/useTemplateService.ts";

export function useTemplateQuery(templateCode: string | undefined) {
  const { getTemplateByCode } = useTemplateService();
  const queryKey = [ReactQueryKeys.TEMPLATE, templateCode];

  const getTemplate = async () => {
    return await getTemplateByCode(templateCode);
  };

  const {
    data,
    error: queryError,
    isError,
    isLoading
  } = useQuery({
    queryKey: queryKey,
    queryFn: getTemplate
  });

  return {
    template: data,
    isLoading,
    queryError,
    isError
  };
}
